import { useParams } from 'react-router-dom'

export const useWorkspaceUrl = () => {
	const { workspaceId } = useParams()
	if (!workspaceId) {
		throw new Error('Workspace Not found')
	}

	return `/${workspaceId}`
}
